<div class="row mt-3 description">
  <div class="col-md-12 d-flex">
    <img src="/assets/img/description.png" class="icon-dimension icon-description" alt="description" />
    &nbsp;
    <p class="text-uppercase pt-2">
      <b>{{ "IDS_DESCRIPTION" | translate }}</b>
    </p>
  </div>
  <div class="row">
    <div class="col-md-12">
      <div class="description-page" [innerHTML]="description()"></div>
    </div>
  </div>
  @if(hasDisclaimer()){
  <div class="col-md-12 mt-4 d-flex">
    <img src="/assets/img/insurance.png" class="icon-dimension" alt="insurance" />
    &nbsp;
    <p class="text-uppercase">
      <b>{{ "IDS_DISCLAIMER" | translate }}</b>
    </p>
  </div>
  <div class="row notes">
    <div class="col-md-12">
      <div class="description-page" [innerHTML]="notes()"></div>
    </div>
  </div>
  }
</div>

<div class="row mt-4 description--mobile">
  <div class="col-12 mb-2 d-flex justify-content-between mobile-tabs  " [class.mobile-tabs--tabbar]="hasDisclaimer()"
    [class.mobile-tabs--expanded]="hasDisclaimer()" [class.mobile-tabs]="hasDisclaimer()" role="tablist"
    aria-label="Description and disclaimer tabs">
    @if(hasDisclaimer()){
    <div class="tab-active-bg" [style.transform]="tabIndicatorTransform()"></div>
    }
    @if(!descriptionClicked()){
      <button (click)="onDescription()" class="text-uppercase gold-tab" [class.gold-tab--active]="!descriptionClicked()"
        role="tab" [attr.aria-selected]="!descriptionClicked()" aria-controls="description-panel" id="description-tab">
        <img src="/assets/img/description.png" class="icon-dimension" alt="description" />
        {{ "IDS_DESCRIPTION" | translate }}
      </button>

      @if(hasDisclaimer()){
      <button (click)="onDisclaimer()" class="text-uppercase gold-tab" [class.gold-tab--active]="descriptionClicked()"
        role="tab" [attr.aria-selected]="descriptionClicked()" aria-controls="disclaimer-panel" id="disclaimer-tab">
        <img src="/assets/img/insurance.png" class="icon-dimension" alt="insurance" />
        {{ "IDS_DISCLAIMER" | translate }}
      </button>
      }
    } @else {
      <button (click)="onDescription()" class="text-uppercase gold-tab" [class.gold-tab--active]="!descriptionClicked()"
        role="tab" [attr.aria-selected]="!descriptionClicked()" aria-controls="description-panel" id="description-tab">
        <img src="/assets/img/description.png" class="icon-dimension" alt="description" />
        {{ "IDS_DESCRIPTION" | translate }}
      </button>
      @if(hasDisclaimer()){
        <button (click)="onDisclaimer()" class="text-uppercase gold-tab" [class.gold-tab--active]="descriptionClicked()"
          role="tab" [attr.aria-selected]="descriptionClicked()" aria-controls="disclaimer-panel" id="disclaimer-tab">
          <img src="/assets/img/insurance.png" class="icon-dimension" alt="insurance" />
          {{ "IDS_DISCLAIMER" | translate }}
        </button>
      }
      }
  </div>

  <div #sliderContainer class="slider-container" [style.height]="containerHeight()" (touchstart)="onTouchStart($event)"
    (touchend)="onTouchEnd($event)">
    <div #sliderTrack class="slider-track" [style.width]="trackWidth()" [style.transform]="trackTransform()">
      <div #descriptionSlide class="slide" [attr.aria-hidden]="descriptionClicked()" id="description-panel" role="tabpanel"
        aria-labelledby="description-tab" [style.flex]="'0 0 ' + slideBasis()" [style.width]="slideBasis()">
        <div class="description-page" [innerHTML]="description()"></div>
      </div>
      @if(hasDisclaimer()){
      <div #disclaimerSlide class="slide" [attr.aria-hidden]="!descriptionClicked()" id="disclaimer-panel" role="tabpanel"
        aria-labelledby="disclaimer-tab" [style.flex]="'0 0 ' + slideBasis()" [style.width]="slideBasis()">
        <div class="description-page" [innerHTML]="notes()"></div>
      </div>
      }
    </div>
  </div>
</div>
